import React, { useRef, useState } from 'react';
import { InfoIcon } from 'lucide-react';
let tooltipCount = 0;
interface InfoTooltipProps {
  label: string;
  text: string;
  align?: 'center' | 'left' | 'right';
}
export const InfoTooltip = ({
  label,
  text,
  align = 'center'
}: InfoTooltipProps) => {
  const [open, setOpen] = useState(false);
  const id = useRef(`neuro-tip-${++tooltipCount}`).current;
  const position = align === 'left' ? 'left-0' : align === 'right' ? 'right-0' : 'left-1/2 -translate-x-1/2';
  return <span className="relative inline-flex" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)} data-id="element-496" data-mp="314glonfuswvm">
      <button type="button" aria-label={`About ${label}`} aria-describedby={open ? id : undefined} onFocus={() => setOpen(true)} onBlur={() => setOpen(false)} onClick={e => {
      e.stopPropagation();
      setOpen(prev => !prev);
    }} onKeyDown={e => {
      if (e.key === 'Escape') setOpen(false);
      e.stopPropagation();
    }} className="inline-flex items-center justify-center rounded-full text-[#6B7280] hover:text-[#111827] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#2563EB] focus-visible:ring-offset-1" data-id="element-497" data-mp="2nck4vfjmy9ej">
        <InfoIcon className="w-4 h-4" strokeWidth={1.75} data-id="element-498" data-mp="2srh2zqlpqunm" />
      </button>
      <span id={id} role="tooltip" className={`pointer-events-none absolute bottom-full mb-2 ${position} z-30 w-64 rounded-lg bg-[#111827] px-3 py-2 text-xs font-normal leading-relaxed text-white shadow-lg transition-[opacity,transform] duration-150 ease-out ${open ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-1'}`} data-id="element-499" data-mp="36j5cdm4kv50w">
        {text}
      </span>
    </span>;
};
export default InfoTooltip;